'use client';
import React, { useEffect, useRef, useState } from 'react';
import './Index.css';

import {
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
  SortDirection,
} from '@mui/material';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';

import CustomPaginationActionsTable from '../../../components/TablePagination';
import StatusRequestData from '../../../Models/StatusRequest';
import { useNavigate } from 'react-router-dom';
import { AttachFile } from '@mui/icons-material';

import SimpleDialogComponent from '../../../components/SimpleDialogComponent';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import SwitchComponent from '../../../components/SwitchComponent';
import { useSearch } from '../../../components/searchContext';
import { useAlert } from '../../../components/alertContext';
import { formatPrice, handleErrorMessage } from '../../../utils/storageUtil';
const Resources: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();

  const navigate = useNavigate();
  const columns: any[] = [
    { field: 'name', headerName: 'Resource Name' },
    { field: 'unit', headerName: 'Unit of Measure' },

    {
      field: 'price',
      headerName: 'Price',
      valueGetter: (value: any, row: any) => formatPrice(value),
    },
    {
      field: 'resourceType',
      headerName: 'Resource Type',
    },
    { field: 'contractorName', headerName: 'Contractor' },
    { field: 'skuCode', headerName: 'SKU' },
    { field: 'reorderPoint', headerName: 'ReOrder point' },
    { field: 'billables', headerName: 'Linked Billable Items' },
    {
      field: 'isQuote',
      headerName: 'Request for Quote',
      valueGetter: (value: any, row: any) => {
        return value === '1' ? 'Yes' : 'No';
      },
    },
    {
      field: 'isAttachment',
      headerName: 'Attachments',
      disableSort: true,
      renderCell: (value: any, row: any) =>
        value ? (
          <IconButton aria-label="Attachments" color="primary">
            <AttachFile />
          </IconButton>
        ) : (
          <span>-</span>
        ),
    },
    { field: 'notes', headerName: 'Notes' },
    { field: 'creator', headerName: 'User' },
    {
      field: 'updated',
      headerName: 'Date Modified',
      valueGetter: (value: any, row: any) => {
        return new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      },
    },
    {
      field: 'status',
      headerName: 'Active',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <SwitchComponent
          checked={value === '1' ? true : false}
          size="small"
          color={'success'}
          name="rsrtable"
          value={row.status}
          handleInputChange={() => {}}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      ),
    },
  ];

  const [attachmentDialogOpen, setAttachmentDialogOpen] =
    useState<boolean>(false);
  const [dialogContent, setDialogContent] = useState<any>();

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [rows, setRows] = useState<any>([]);

  const handleAttachmentDialog = (state: boolean) => {
    setAttachmentDialogOpen(state);
  };

  useEffect(() => {
    if (searchQuery || paginate || isInitialLoad.current) {
      fetchData();
    }
    isInitialLoad.current = false;
  }, [searchQuery, paginate]);
  const StatusUpdate = async (dataObj: StatusRequestData) => {
    try {
      const response = await HttpService.patch(
        Constants.apiURL + Constants.resourcesURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        fetchData();
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: 'Unable to deactive item as there is currently stock',
        open: true,
      });
    }
  };
  const getResourceRecord = async (id: any) => {
    return new Promise(async (resolve, reject) => {
      const response = await HttpService.get(
        Constants.apiURL + Constants.resourcesURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        resolve(response.resource);
      } else {
        resolve(null);
      }
    });
  };
  const getMediaRecord = async (id: any) => {
    return new Promise(async (resolve, reject) => {
      const response = await HttpService.get(
        Constants.apiURL + Constants.mediaURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        resolve(response.media);
      } else {
        resolve(null);
      }
    });
  };
  const handleDownloadFile = async (ID: any) => {
    const media: any = await getMediaRecord(ID);
    if (media) {
      window.open(media, '_blank');
    }
  };

  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.resourcesURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);

        setTotalRecords(response.data.total);
        handleOrderBy('name');
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleCustomTableClick = async (row: any) => {
    const resource = await getResourceRecord(row.id);

    const fileElements = renderDialogContent(resource);
    // console.log(`fileElements`);
    // console.log(fileElements);
    // console.log(`fileElements`);
    if (fileElements) {
      setDialogContent(fileElements);
      setAttachmentDialogOpen(true);
    }
  };
  const renderDialogContent = (resource: any) => {
    const renderElements: any = [];
    let mediaData: any;
    if (resource) {
      //  if (resource.isQuote === '1') {
      const details = resource.details;
      for (let i = 0; i < details.length; i++) {
        mediaData = details[i].media;
        if (mediaData.length > 0) {
          //console.log(mediaData);
          for (let j = 0; j < mediaData.length; j++) {
            console.log(mediaData[j]);
            const recordID: any = mediaData[j].id;

            renderElements.push(
              <div
                className="dialog-img-element"
                onClick={() => {
                  //console.log(recordID);
                  handleDownloadFile(recordID);
                }}
              >
                <span>{mediaData[j]['name']}</span>
              </div>
            );
          }
        }
      }
      //   }
      // if (resource.isQuote === '0') {
      //   mediaData = resource.media;
      //   for (let mi = 0; mi < mediaData.length; mi++) {
      //     const recordID: any = mediaData[mi].id;
      //     renderElements.push(
      //       <div
      //         className="dialog-img-element"
      //         onClick={() => {
      //           //console.log(recordID);
      //           handleDownloadFile(recordID);
      //         }}
      //       >
      //         <span>{mediaData[mi]['name']}</span>
      //       </div>
      //     );
      //   }
      // }
      if (renderElements.length > 0) {
        return <div className="dialog-files">{renderElements}</div>;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
  const handleStatus = (row: any) => {
    let status = '1';
    if (row.status === '1') {
      status = '0';
    }
    if (row.status === '0') {
      status = '1';
    }
    StatusUpdate({ id: row.id, status: status });
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  return (
    <Stack>
      <Box className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <div className="mt-2">
              <Paper sx={{ width: '100%' }} className="mt-4">
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6"> Resources</Typography>
                  <AddButtonComponent
                    onClick={() => {
                      navigate('/data-management/resource-items/Add');
                      //setDialogOpen(true);
                    }}
                    keyName="quoteaddicon"
                    label="Add New"
                  />
                </Box>
                <CustomPaginationActionsTable
                  rows={rows}
                  columns={columns}
                  totalRecords={totalRecords}
                  handlePagination={handlePagination}
                  handleRowClick={(row) => {
                    navigate('/data-management/resource-items/' + row.id);
                    //console.log(data);
                  }}
                  paginationModel={{
                    page: paginate.offset,
                    pageSize: paginate.limit,
                  }}
                  handleStatus={handleStatus}
                  order={order}
                  orderBy={orderBy}
                  handleOrderBy={handleOrderBy}
                  customClick={async (row) => {
                    handleCustomTableClick(row);
                  }}
                />
              </Paper>
            </div>
          </div>
        </section>
        {
          <SimpleDialogComponent
            title={'Attachments'}
            dialogContent={dialogContent}
            open={attachmentDialogOpen}
            handleClose={() => {
              handleAttachmentDialog(false);
            }}
          />
        }
        <AlertMessageComponent
          type={alert.type}
          open={alert.open}
          handleClose={handleCloseAlert}
          message={alert.message}
        />
      </Box>
    </Stack>
  );
};
export default Resources;
